// extracted by mini-css-extract-plugin
export default {"root":"FloatWebCam_root__6ugfx","title":"FloatWebCam_title__AGpM-","body":"FloatWebCam_body__4V+ct","footer":"FloatWebCam_footer__x-Dgg","error":"FloatWebCam_error__ohwfx"};